import React from "react";

function ProjectCellTitle({ cell, row }) {
  return (
    <div className="inner-tables-infos">
      <span className="normalTitle">{cell}</span>
      <span className="subTitle">{row.CodeProject}</span>
    </div>
  );
}

export default ProjectCellTitle;
